function getCookie(name) {
  return document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';
}

function getReferralInfo() {
  let referral = getCookie('referral');
  // Since we return if there is no referral, we can default this to true
  let isReferral = true;
  // If no referral cookie, look for an affiliate
  // Referrals take precedent so we want to look for them first.
  if (!referral) {
    isReferral = false;
    referral = getCookie('affiliate');
  }
    // If there's still not a referral, then return
  if (!referral) return {};

  // Since we can't use flags in Shopify, we're using the cookie properties
  // to know if this is an old or new referral
  const isNewReferral = referral.includes('fbuy') || referral.includes('code');
  // If they get to the shop with the old cookie, we're going to remove it
  // Then they can get a new cookie on dotcom.
  if (!isNewReferral) {
    document.cookie = `referral=;expires=Thu, 20 Oct 1994 00:00:00;path=/;domain=.glowforge.com`;
    return {};
  }

  const referralDecode = decodeURI(referral);
  const referralName = referralDecode.substring(referralDecode.indexOf('name|') + 5, referralDecode.indexOf('code|'));
  const referralCode = referralDecode.substring(
    referralDecode.indexOf('code|') + 5,
    isReferral ? referralDecode.indexOf('fbuy|') : referralDecode.indexOf('params|'),
  );

  if (!referralCode) return {};

  // If it's not a referral and it got here, it's an affiliate
  // So we can use one value for both of them
  return {
    referrerName: referralName,
    code: isReferral ? referralCode : null,
    isReferral,
    isAffiliate: !isReferral,
    promoLink: isReferral
      ? null
      : {
          id: referralCode,
        },
  };
}

function attachFormFields(referralInfo, element) {
  const form = element.closest('form');
  if (!form) return;

  const hasDiscount = form.querySelector('[name="discount"]');
  const referralCodeAttribute = hasDiscount ? 'friendbuyReferralCode' : 'Referral Code No Discount';
  const promoLinkAttribute = hasDiscount ? 'Promo Link' : 'Promo Link No Discount';

  const attributes = {
    [`${referralCodeAttribute}`]: referralInfo?.code,
    [`${promoLinkAttribute}`]: referralInfo?.promoLink?.id,
  };

  const attributeFields = Object.keys(attributes).map((key) => {
    const value = attributes[key];
    return value ? `<input type="hidden" name="attributes[${key}]" value="${attributes[key]}"/>` : '';
  });

  element.insertAdjacentHTML('afterend', attributeFields.join(''));
}

function promoDisclaimers() {
  const referralComponents = document.querySelectorAll('.referral-hide, .referral-show');
  referralComponents.forEach((component) => {
    component.style.display = component.classList.has('referral-show') ? 'block' : 'none';
  });
}

/**
 * Based on element type and action:
 *
 * True: shows the element or activates the disabled input
 * False: hides the element or deactivates the input.
 *
 * @param   {HTMLElement}  element
 * @param   {boolean}  action
 * @return  {void}
 */
function elementAction(element, action) {
  if(action === false){
    element.remove();
    return;
  }
  switch (element.tagName) {
    case 'INPUT':
      element.disabled = false;
      break;
    default:
      element.classList.remove('hidden');
      break;
  }
}

function renderReferrals() {
  const referralInfo = getReferralInfo();
  const hasReferral = Object.keys(referralInfo).length > 0

  if (hasReferral){
    promoDisclaimers();
  }

  const referralElements = document.querySelectorAll('[data-referral-condition]');
  referralElements.forEach((element) => {
    switch (element.dataset.referralCondition) {
      case 'Add':
        elementAction(element, hasReferral);
        attachFormFields(referralInfo, element);
        break;
      case 'Remove':
        elementAction(element, !hasReferral);
        break;
      default:
        elementAction(element, true);
        break;
    }
  });
}

renderReferrals();
